export default function Firebase() {
    return (
        <>
            <div className="w-24 h-24 p-2 z-10  box-border rounded-full bg-white bg-opacity-60 bg-blur-xl backdrop-filter shadow-white-box transition-transform transform hover:scale-105">
                <img src="/firebase.png" className="w-full h-full object-contain" alt="" />
            </div>
        </>
    )
}